import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// Pages that an ID-unverified member is still allowed to visit so they can
// upload their ID, see billing state, contact support, and read terms.
const ID_UNVERIFIED_ALLOWED = new Set([
  "/profile", "/billing", "/billing/return", "/billing/success", "/support", "/terms", "/privacy", "/cookies",
]);

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[var(--hh-sage)]" data-testid="auth-loading">
        <span className="label-eyebrow">Loading</span>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  // ID-verification gate. Members can't access the wider platform until the
  // admin approves their uploaded ID. The Profile page is the upload point;
  // a few essential utility routes remain accessible.
  if (user.is_id_verified === false && user.role !== "admin") {
    const ok = ID_UNVERIFIED_ALLOWED.has(location.pathname) || location.pathname.startsWith("/billing/");
    if (!ok) {
      return <Navigate to="/profile?id_pending=1" state={{ from: location }} replace />;
    }
  }
  return children;
}
